function setupImageWithCollapsibleSection(section) {
  if (!section || section.dataset.iwcAccordionInitialized === 'true') {
    return;
  }

  const items = section.querySelectorAll('.image-with-collapsible__accordion-details');
  if (!items.length) {
    section.dataset.iwcAccordionInitialized = 'true';
    return;
  }

  function closeOthers(activeItem) {
    items.forEach(function (item) {
      if (item !== activeItem) {
        item.open = false;
      }
    });
  }

  items.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (item.open) {
        closeOthers(item);
      }
    });
  });

  let hasOpenItem = false;
  items.forEach(function (item) {
    if (!item.open) {
      return;
    }

    if (!hasOpenItem) {
      hasOpenItem = true;
      return;
    }

    item.open = false;
  });

  section.dataset.iwcAccordionInitialized = 'true';
}

function initImageWithCollapsibleAccordion() {
  const sections = document.querySelectorAll('.section-image-with-collapsible');
  sections.forEach(setupImageWithCollapsibleSection);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initImageWithCollapsibleAccordion);
} else {
  initImageWithCollapsibleAccordion();
}
